/* import __COLOCATED_TEMPLATE__ from './brand-signup-create-company.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, getProperties } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { object, string } from 'yup';
import { validateSchema } from 'sh-www/utils/validators';

const CLASS_NAME = 'GLM-brand-signup-create-company';

const SCHEMA = object({
  'company_name': string()
    .required('Please enter a company name')
    .min(2, 'Please enter a company name'),

  'website': string()
    .required('Please enter a company website')
    .min(2, 'Please enter a company website'),

  'location': object().required('You must select a location'),
  'companyImage': object().required('You must upload a logo'),
});

class BrandSignupCreateCompany extends Component {
  @service session;

  /** @var {Location|null} */
  @tracked location = this.session.currentUser.company?.location;
  @tracked company_name = this.session.currentUser.company?.name ?? '';
  @tracked website = this.session.currentUser.company?.website ?? '';
  /** @var {Image|null} */
  @tracked companyImage = this.session.currentUser.company?.image;
  @tracked locationInputValue = this.session.currentUser.company?.location?.formattedAddress ?? '';
  @tracked errors = null;

  get className() {
    return CLASS_NAME;
  }

  get submitDisabled() {
    return (
      this.company_name.length < 2 ||
      this.website.length < 2 ||
      this.location == null ||
      this.companyImage == null ||
      this.createOrUpdateCompanyTask.isRunning
    );
  }

  /**
   * @param {Location} location
   */
  @action
  handleLocationChange(location) {
    this.location = location;
    this.locationInputValue = location?.formattedAddress ?? '';

    if (this.errors?.location) {
      this.errors = { ...this.errors, location: undefined };
    }
  }

  /**
   * @param {string} value
   */
  @action
  handleLocationInput(value) {
    this.locationInputValue = value;
  }

  /**
   * @param {Image|null} image
   */
  @action
  updateCompanyImage(image) {
    this.companyImage = image;
  }

  @action
  setFormField(field, value) {
    this[field] = value;

    if (this.errors?.[field]) {
      this.errors = { ...this.errors, [field]: undefined };
    }
  }

  @task
  *createOrUpdateCompanyTask(e) {
    e.preventDefault();

    const [_, validationErrors = null] = validateSchema(
      getProperties(this, Object.keys(SCHEMA.fields)),
      SCHEMA,
    );

    this.errors = validationErrors;

    if (this.errors) {
      return;
    }

    try {
      yield this.args.createOrUpdateCompany(
        this.company_name,
        this.companyImage,
        this.website,
        this.location,
      );
    } catch (error) {
      this.errors = {
        company_name: error.errors?.['name']?.[0],
        website: error.errors?.['website']?.[0],
        location: error.errors?.['location_id']?.[0],
      };
    }
  }
}

export default BrandSignupCreateCompany;
